import { Component, OnInit, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import { ClientService } from '../client.service';
import { OAuthClientDetail } from '../oauth-client-detail';
import { ClientDto } from '../client-dto';
import { UserService } from '../../common/api/user.service';

@Component({
    selector : 'app-client-detail',
    templateUrl : './client-detail.component.html',
})
export class ClientDetailComponent implements OnInit {
    createdAt: string;
    updatedAt: string;
    client = new OAuthClientDetail();
    clientDto = new ClientDto();
    constructor(private route: ActivatedRoute, public router: Router
      , private clientService: ClientService, private userService: UserService) {}

    ngOnInit() {
      const clientId = this.route.snapshot.params['clientId'];
      if (clientId == null || clientId.length < 1) {
        alert('잘못된 접근입니다.');
        this.router.navigate(['/client/list']);
      } else {
        this.getClient(clientId);
      }
    }

    createClient() {
      if (this.client.clientName == null || this.client.clientName.length < 1) {
        alert('클라이언트ID에 연결할 이름을 입력해주세요 ');
        return;
      }

      if (this.client.clientEmail == null || this.client.clientEmail.length < 1) {
        alert('연락 가능한 이메일을 입력해주세요');
        return;
      }

      const grantTypes = new Array<string>();
      $($('input[name=grantTypes]:checkbox').each(function() {
        if ($(this).is(':checked')) {
          grantTypes.push($(this).val());
        }
      }));

      if (grantTypes.length < 1) {
        alert('권한 부여 타입을 하나 이상 선택해주세요.');
        return;
      }

      this.clientDto.grantTypes = grantTypes;

      const scopes = new Array<string>();
      $($('input[name=scope]:checkbox').each(function() {
        if ($(this).is(':checked')) {
          scopes.push($(this).val());
        }
      }));

      if (scopes.length < 1) {
        alert('스코프를 하나 이상 선택해주세요.');
        return;
      }
      this.clientDto.scopes = scopes;

      this.clientService.modifyClient(this.clientDto, this.client.clientId).subscribe(response => {
        alert('등록되었습니다.');
        this.router.navigate(['/client/list']);
      }, error => {
        if (error.status === 401) {
          alert('로그인이 만료되었거나 잘못된 인증입니다.\n다시 로그인 해주세요');
          this.userService.logout();
        } else {
          alert('오류가 발생했습니다.');
        }
      });
    }

    getClient(clientId) {
      this.clientService.getClient(clientId).subscribe(response => {
        this.client = response.json();
        this.createdAt = this.client.createdAt.year + '-' + this.client.createdAt.monthValue + '-' + this.client.createdAt.dayOfMonth;
        this.updatedAt = this.client.updatedAt.year + '-' + this.client.updatedAt.monthValue + '-' + this.client.updatedAt.dayOfMonth;
        this.setCheckbox(this.client);
        this.clientDto.clientEmail = this.client.clientEmail;
        this.clientDto.clientName = this.client.clientName;
      }, error => {
        if (error.status === 401) {
          alert('로그인이 만료되었거나 잘못된 인증입니다.\n다시 로그인 해주세요');
          this.userService.logout();
        } else {
          alert('오류가 발생했습니다.');
        }
      });
    }

    setCheckbox(client: OAuthClientDetail) {

      const grantTypes = client.authorizedGrantTypes.split(',');

      const scope = client.scope.split(',');
      if (grantTypes != null && grantTypes.length > 0) {
        for (const grantType of grantTypes) {
          if (grantType.length > 0) {
            $($('input[value=' + grantType.toUpperCase() + ']:checkbox')).each(function() {
              $(this).attr('checked', 'true');
            });
          }
        }
      }

      if (scope != null && scope.length > 0) {
        for (const s of scope) {
          if (s.length > 0 ) {
            $($('input[value=' + s.toUpperCase() + ']:checkbox')).each(function() {
              $(this).attr('checked', 'true');
            });
          }
        }
      }

    }

    removeClient(clientId) {
      if (confirm ('삭제하시겠습니까?')) {
        this.clientService.removeClient(clientId).subscribe(response => {
          alert('삭제되었습니다.');
          this.router.navigate(['/client/list']);
        }, error => {
          if (error.status === 401) {
            alert('로그인이 만료되었거나 잘못된 인증입니다.\n다시 로그인 해주세요');
            this.userService.logout();
          } else {
            alert('오류가 발생했습니다.');
          }
        });
      }
    }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/client/detail/client-detail.component.ts